import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'questionBreakHtml'
})
export class QuestionBreakHtmlPipe implements PipeTransform {

  //改行コードをマークに変換する
  transform(str:string): string {
    str = str.replace(/\r?\n/g, '<br>');
    return str;
  }
}


// WEBPACK FOOTER //
// ./src/app/pipes/question-break-html.pipe.ts